import React, { useState } from "react";
import "./InfoHeader.css";
import LanguageSelector from "./LanguageSelector";
import translations from "./Translations";

const MenuItem = ({ link, text, typeClassname }) => {
  return (
    <>
      <a href={link} className={typeClassname ? typeClassname : "menu-item"}>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </a>
    </>
  );
};

const iconHome =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16"><path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"/></svg>';

const InfoHeader = () => {
  const [language, setLanguage] = useState(
    localStorage.getItem("language_dsm")
      ? localStorage.getItem("language_dsm")
      : "it"
  );

  const onChangeLanguage = (type) => {
    setLanguage(type);
    localStorage.setItem("language_dsm", type);
  };

  const lang = (localStorage.getItem("language_dsm") || "IT").toUpperCase();
  const t = translations[lang];

  return (
    <header style={{ textAlign: "center" }}>
      <div
        style={{
          color: "#003366",
          backgroundColor: "#FAFAFA",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "20px",
          padding: "10px 20px",
        }}
      >
        <div style={{ flex: 1 }}></div> {/* Spacer sinistro */}
        <div style={{ flex: 1, textAlign: "center" }}>
          <a
            href={"/home"}
            style={{
              textDecoration: "none",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            <strong>DIVISIONE DI SPETTROMETRIA DI MASSA 1972</strong>
          </a>
        </div>
        <div style={{ flex: 1, textAlign: "right" }}>
          <LanguageSelector />
        </div>
      </div>

      <div className="menu-container">
        <MenuItem
          link="/home"
          text={iconHome}
          typeClassname={"menu-item-home"}
        />
        <MenuItem link="/board_of_directors" text={t.CONSIGLIO_DIRETTIVO} />
        <MenuItem link="/program_lines" text={t.LINEE_PROGRAMMATICHE} />
        <MenuItem link="/regulation" text={t.REGOLAMENTO} />
        <MenuItem link="/history" text={t.STORIA_DSM} />
        <MenuItem link="/in_memory_of_people" text={t.IN_RICORDO_DI} />
        <MenuItem link="/contact" text={t.CONTATTI} />
        <MenuItem link="/company" text={t.ALTRE_SOCIETA} />
        <MenuItem link="/feedback" text={t.FEEDBACK} />
      </div>
    </header>
  );
};

export default InfoHeader;
